var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-button',{attrs:{"sync":_vm.sync,"id":_vm.id,"value":_vm.model,"color":_vm.color,"disabled":_vm.disabled},on:{"change":_vm.onChangeEventHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }